import React, { Component } from 'react';
import { Grid, Form, Button } from 'semantic-ui-react';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { TitledCard, MappingModal } from 'Components/';
import { DCImportFieldEnum as Fields } from 'Common/FieldEnum';
import { DC_IMPORT_SETTINGS_FORM } from 'Common/FormEnum';
import { SelectField } from 'Common/SemanticWrapper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { convertEnumToDropdownArray } from 'Common/Constants/Enumeration/ConvertEnumToDropdownArray';
import { ImportTypeEnum, CaseTypeOptions } from '../../helpers/Constants';
import {
  getCaseTypeMappings,
  saveCaseTypeMappings,
} from '../../state/fileconfig/actions';

class ImportSettingsForm extends Component {
  state = {
    showMappingModal: false,
    finalMappedValues: [],
    dataMapped: {},
  };

  onMappingSave = data => {
    this.props.saveCaseTypeMappings(data);
    this.setState({ showMappingModal: false });
  };

  onMappingClose = () => {
    this.setState({ showMappingModal: false });
  };

  onMapCaseTypeClick = () => {
    this.setState({ showMappingModal: true });
  };

  getCaseTypes = () => {
    if (this.props.caseTypes) {
      return this.props.caseTypes
        .filter(caseType => caseType.Id > 0 && caseType.Enabled)
        .map((caseType, i) => {
          return {
            key: i,
            text: caseType.Description,
            value: caseType.Id,
          };
        });
    } else {
      return [];
    }
  };

  getImportTypes = () => {
    let modifiedEnum = ImportTypeEnum;
    delete modifiedEnum.None;

    return convertEnumToDropdownArray(modifiedEnum);
  };

  renderCaseTypeAction = () => {
    const { formValues, loading } = this.props;

    if (formValues[Fields.UseCaseTypeMapping]) {
      return (
        <Button
          primary
          content="Map Case Type"
          className={'dc-import--case-type-button'}
          onClick={this.onMapCaseTypeClick}
          disabled={
            loading ||
            formValues[Fields.ImportType] !== ImportTypeEnum.Direct_Certified
          }
        />
      );
    } else {
      return (
        <Field
          component={SelectField}
          name={Fields.DefaultCaseType}
          options={this.getCaseTypes()}
          label={'Default Case Type'}
          disabled={
            loading ||
            formValues[Fields.ImportType] !== ImportTypeEnum.Direct_Certified
          }
        />
      );
    }
  };

  componentDidMount() {
    this.props.getCaseTypeMappings();
  }

  componentDidUpdate(prevProps) {
    const { change, formValues } = this.props;
    if (
      formValues &&
      formValues[Fields.ImportType] !== ImportTypeEnum.Direct_Certified &&
      prevProps.formValues[Fields.ImportType] !== formValues[Fields.ImportType]
    ) {
      change(DC_IMPORT_SETTINGS_FORM, Fields.UseCaseTypeMapping, false);
      change(DC_IMPORT_SETTINGS_FORM, Fields.DefaultCaseType, null);
    }
    if (
      formValues &&
      formValues[Fields.UseCaseTypeMapping] === true &&
      prevProps.formValues[Fields.UseCaseTypeMapping] !==
        formValues[Fields.UseCaseTypeMapping]
    ) {
      change(DC_IMPORT_SETTINGS_FORM, Fields.DefaultCaseType, null);
    }
  }

  render() {
    const {
      dispatch,
      formValues,
      loading,
      caseTypeMapping,
      caseTypeMappingInitial,
    } = this.props;

    return (
      <Form>
        <TitledCard title={'Import Settings'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={14}>
                <Grid>
                  <Grid.Row className={'remove-spacing'}>
                    <Grid.Column width={6}>
                      <Field
                        name={Fields.ImportType}
                        component={SelectField}
                        label={'Import Type'}
                        options={this.getImportTypes()}
                        disabled={loading}
                      />
                    </Grid.Column>
                    <Grid.Column width={10} className="input-group--btn-group">
                      {formValues[Fields.ImportType] ===
                        ImportTypeEnum.Direct_Certified && (
                        <ReduxFormButtonGroup
                          dispatch={dispatch}
                          formName={DC_IMPORT_SETTINGS_FORM}
                          fieldName={Fields.UseCaseTypeMapping}
                          value={formValues[Fields.UseCaseTypeMapping]}
                          options={CaseTypeOptions}
                          label={'Case Type'}
                          disabled={
                            loading ||
                            formValues[Fields.ImportType] !==
                              ImportTypeEnum.Direct_Certified
                          }
                        />
                      )}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row className={'remove-spacing'}>
                    <Grid.Column width={6} />
                    <Grid.Column width={6}>
                      {formValues[Fields.ImportType] ===
                        ImportTypeEnum.Direct_Certified &&
                        this.renderCaseTypeAction()}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <MappingModal
          showDialog={this.state.showMappingModal}
          title={'Map Case Types'}
          data={caseTypeMapping}
          initialData={caseTypeMappingInitial}
          mappingOptions={this.getCaseTypes()}
          saveCallback={this.onMappingSave}
          closeCallback={this.onMappingClose}
        />
      </Form>
    );
  }
}

const validate = values => {
  let errors = {};

  if (!values[Fields.ImportType]) {
    errors[Fields.ImportType] = 'Import Type is required.';
  }

  if (
    values[Fields.ImportType] === ImportTypeEnum.Direct_Certified &&
    !values[Fields.UseCaseTypeMapping] &&
    !values[Fields.DefaultCaseType]
  ) {
    errors[Fields.DefaultCaseType] = 'Default Case Type is required.';
  }

  return errors;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues(DC_IMPORT_SETTINGS_FORM)(state),
    caseTypeMapping: state.DCImportState.fileConfig.caseTypeMapping,
    caseTypeMappingInitial:
      state.DCImportState.fileConfig.caseTypeMappingInitial,
  };
};

ImportSettingsForm = withRouter(
  connect(
    mapStateToProps,
    { change, getCaseTypeMappings, saveCaseTypeMappings }
  )(ImportSettingsForm)
);

ImportSettingsForm = reduxForm({
  form: DC_IMPORT_SETTINGS_FORM,
  validate,
})(ImportSettingsForm);

export { ImportSettingsForm };



// WEBPACK FOOTER //
// ./src/pages/dcimport/components/importsettings/ImportSettingsForm.js